/* PhotoHouse V3 — conservative progressive UX. No cart or variant API calls. */
(function(){
  'use strict';
  function each(nodes,fn){Array.prototype.forEach.call(nodes||[],fn);}
  function retainCollectionSort(){
    if(!document.body.classList.contains('template-collection'))return;
    var current=new URLSearchParams(window.location.search);
    var sort=current.get('sort_by');
    // Shopify's native links remain intact, only preserve the visible sort selection.
    if(!sort)return;
    each(document.querySelectorAll('.ph-v1__filter-chips a[href]'),function(link){
      try {
        var destination=new URL(link.href,window.location.href);
        if(destination.origin!==window.location.origin)return;
        if(!destination.searchParams.has('sort_by')){
          destination.searchParams.set('sort_by',sort);
          link.href=destination.pathname+destination.search+destination.hash;
        }
      } catch(_err) { /* Keep Shopify's original href. */ }
    });
  }
  function mirrorCartCount(){
    var output=document.querySelector('[data-ph-v3-cart-count]');
    var original=document.querySelector('.sidebar__cart-handle .count');
    if(!output||!original)return;
    var sync=function(){output.textContent=(original.textContent||'').trim();};
    var observer=new MutationObserver(sync);
    observer.observe(original,{childList:true,characterData:true,subtree:true});
    sync();
  }
  function closeOtherMenus(){
    each(document.querySelectorAll('.ph-v3__topbar-parent'),function(menu){
      menu.addEventListener('toggle',function(){
        if(!menu.open)return;
        each(document.querySelectorAll('.ph-v3__topbar-parent'),function(other){if(other!==menu)other.open=false;});
      });
    });
    document.addEventListener('keydown',function(evt){
      if(evt.key!=='Escape')return;
      each(document.querySelectorAll('.ph-v3__topbar-parent[open]'),function(menu){menu.open=false;});
    });
  }
  function mount(){
    if(!document.body||!document.body.classList.contains('ph-v3'))return;
    retainCollectionSort();
    if(document.body.classList.contains('ph-v3-header')){
      mirrorCartCount();
      closeOtherMenus();
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount);
  else mount();
  document.addEventListener('shopify:section:load',retainCollectionSort);
}());
